(function () {
  // Gap between the two copies of the name (must match padding-left in CSS).
  var GAP = 40;
  // Constant scroll speed in px/s — identical for every product.
  var SPEED = 70;

  function measureAndMarquee(link) {
    var track = link.querySelector('.header__drops-name-track');
    var nameBox = link.querySelector('.header__drops-name');
    if (!track || !nameBox) return;

    var firstText = track.querySelector('.header__drops-name-text');
    if (!firstText) return;

    // Full natural width of the text (scrollWidth ignores the ellipsis clip).
    var fullWidth = firstText.scrollWidth;

    // Only loop if the text is actually wider than its visible box.
    if (fullWidth - nameBox.clientWidth > 2) {
      // One loop = first copy width + the gap before the second copy. When the
      // track shifts by exactly this, the second copy sits where the first
      // began, so restarting at 0 is seamless.
      var distance = fullWidth + GAP;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
      track.style.setProperty('--marquee-duration', (distance / SPEED).toFixed(2) + 's');
      track.classList.add('is-overflowing');
    }
  }

  function reset(link) {
    var track = link.querySelector('.header__drops-name-track');
    if (track) track.classList.remove('is-overflowing');
  }

  function init() {
    document.querySelectorAll('.header__drops-link').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        measureAndMarquee(link);
      });
      link.addEventListener('mouseleave', function () {
        reset(link);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
